import * as Action from "./action";

const defineInitialState = () => ({
  isAuthenticated: false,
  session: null,
});

export function reducer(state = defineInitialState(), action) {
  switch (action.type) {
    case Action.$reset.ACTION:
      return defineInitialState();
    case Action.$setSession.ACTION:
      return {
        isAuthenticated: action?.session ? true : false,
        session: action?.session,
      };
    default:
      return state;
  }
}

export function persister({ isAuthenticated, session }) {
  return {
    isAuthenticated,
    session,
  };
}
